import { render, staticRenderFns } from "./doCopyWork.vue?vue&type=template&id=35755b56&scoped=true"
import script from "./doCopyWork.vue?vue&type=script&lang=js"
export * from "./doCopyWork.vue?vue&type=script&lang=js"
import style0 from "./doCopyWork.vue?vue&type=style&index=0&id=35755b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35755b56",
  null
  
)

export default component.exports